import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { usePostHog } from "posthog-js/react";
import { useDispatch, useSelector } from "react-redux";
import { AuthoritiesEnum, IntegrationTypeEnum } from "~/types/enums";
import { Card, InputToggle, Picture, Text } from "~/components-shared";
import integrationsActionCreators from "~/store/integrations/actions";
import integrationSelectors from "~/store/integrations/selectors";
import useAbacExt from "~/hooks/abac";
import api from "~/lib/api";
import googleLogo from "~/assets/i/apps/google.svg";
import styled, { useTheme } from "styled-components";
const Actions = styled.div`
  position: relative;
  z-index: 2;
`;
const authorities = [AuthoritiesEnum.INTEGRATIONS_READ, AuthoritiesEnum.ONBOARDING_COMPANY_INTEGRATIONS_WRITE, AuthoritiesEnum.SIGN_UP_INTEGRATE];
const GoogleIntegrationCard = _ref => {
  let {
    ...rest
  } = _ref;
  const {
    userHasOneOf
  } = useAbacExt();
  const theme = useTheme();
  const dispatch = useDispatch();
  const posthog = usePostHog();
  const integration = useSelector(integrationSelectors.getMemberIntegrationByType(IntegrationTypeEnum.GOOGLE));
  const handleToggle = value => {
    if (value) {
      api.googleInstall().then(_ref2 => {
        let {
          path
        } = _ref2;
        const width = 560;
        const height = 700;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;
        window.open(path, "Google Auth", `width=${width},height=${height},left=${left},top=${top}`);
      });
      posthog.capture(`Google Integration – Install`);
    } else if (integration?.id) {
      dispatch(integrationsActionCreators.deleteMemberStarted(integration.id));
      posthog.capture(`Google Integration – Uninstall`);
    }
  };
  return /*#__PURE__*/React.createElement(Card, _extends({
    elemBefore: /*#__PURE__*/React.createElement(Picture, {
      src: googleLogo,
      width: "30px",
      height: "30px",
      border: "squared",
      color: theme.colors.borders.primary,
      s: {
        mr: 2
      }
    }),
    title: /*#__PURE__*/React.createElement(Text, {
      element: "h3",
      display: "inline-block"
    }, "Google"),
    elemAfter: /*#__PURE__*/React.createElement(Actions, null, /*#__PURE__*/React.createElement(InputToggle, {
      value: !!integration,
      onChange: (value, event) => {
        event.stopPropagation();
        handleToggle(value);
      },
      disabled: !userHasOneOf(authorities)
    })),
    collapsed: true,
    s: {
      mb: 3
    }
  }, rest));
};
export default GoogleIntegrationCard;